module.exports = __webpack_public_path__ + "static/media/size.7b3ed8a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/size.png
// module id = 346
// module chunks = 0